module.exports = __webpack_public_path__ + "static/img/1.8c73f535.jpg";